@if(props.label) {
    <div class="p-field">
        <label>{{props.label}}</label>
        <p-select [options]="getOptions"
                  [placeholder]="props.placeholder || ''"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [showClear]="false"
                  [filter]="props.filter || false"
                  [filterBy]="props.filterBy"
                  [disabled]="props.disabled || false"
                  [formlyAttributes]="field"
                  [formControl]="formControl"
                  [fluid]="true" />
        @if(showError) {
            <small class="p-error">
                <formly-validation-message [field]="field" />
            </small>
        }
    </div>
} @else {
    <p-select [options]="getOptions"
              [placeholder]="props.placeholder || ''"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [showClear]="false"
              [filter]="props.filter || false"
              [filterBy]="props.filterBy"
              [disabled]="props.disabled || false"
              [formlyAttributes]="field"
              [formControl]="formControl"
              [fluid]="true" />
    @if(showError) {
        <small class="p-error">
            <formly-validation-message [field]="field" />
        </small>
    }
}
